import React from "react";
import { Form, Input, Typography } from "antd";
import { CONTROL } from "pages/MarketingPages/FieldInput";

const { Text } = Typography;

/**
 * The two fields of one glossary pair.
 *
 * Split from the screen the way `RedirectForm` is, so the list logic and the
 * validation stay legible separately. The parent owns the antd `Form` instance
 * and does the submitting.
 *
 * Validation is thin on purpose: the API is the only thing that can rule on
 * uniqueness (which is case-insensitive there), so a second opinion here would
 * only be a chance to disagree with it. What is checked is the one mistake the
 * server's answer would not make obvious — a translation identical to the term.
 */
export default function GlossaryTermForm({ form, onSubmit }) {
  return (
    <Form form={form} layout="vertical" onFinish={onSubmit} requiredMark={false}>
      <Form.Item
        name="source"
        label="Термин на български"
        extra={
          <Text type="secondary">
            Както се среща в текста, напр. <code>ветеринарен лекар</code>
          </Text>
        }
        rules={[{ required: true, whitespace: true, message: "Терминът на български е задължителен" }]}
      >
        <Input style={CONTROL} placeholder="ветеринарен лекар" maxLength={255} />
      </Form.Item>

      <Form.Item
        name="target"
        label="Превод на английски"
        extra={<Text type="secondary">Какво трябва да използва DeepL вместо собствената си догадка</Text>}
        rules={[
          { required: true, whitespace: true, message: "Преводът на английски е задължителен" },
          {
            validator: (_, value) => {
              const source = form.getFieldValue("source");
              // Compared case-insensitively, because the server treats a term
              // and its differently-cased twin as the same term.
              const same =
                value &&
                source &&
                value.trim().toLowerCase() === source.trim().toLowerCase();
              return same
                ? Promise.reject(new Error("Преводът съвпада с термина"))
                : Promise.resolve();
            },
          },
        ]}
      >
        <Input style={CONTROL} placeholder="veterinarian" maxLength={255} />
      </Form.Item>
    </Form>
  );
}
